<template>
  <el-dialog :visible="visible" :title="title" :close-on-click-modal="false" :modal="false" @close="$emit('update:visible', false)">
    <div class="flex-row item-center">
      <span class="mr5">列：</span>
      <span v-show="title === '批量修改'" class="mr10">
        <el-select v-model="header" filterable clearable size="mini" placeholder="请选择标题">
          <el-option v-for="(value, index) in headers" :key="index" :value="value" :label="value" />
        </el-select>
      </span>
      <span v-show="title === '增加列'" class="mr10">
        <el-input v-model="header" placeholder="请输入标题" clearable size="mini" />
      </span>
      <el-input v-model="content" placeholder="请输入内容" clearable size="mini" />
    </div>
    <span slot="footer">
      <el-button class="mr10" size="mini" @click="$emit('update:visible', false)">取消</el-button>
      <el-button type="primary" size="mini" @click="onConfirm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '批量修改' },
    confirm: { type: Function, default: () => {} },
    headers: { type: Array, default: () => [] },
  },
  data() {
    return {
      header: '',
      content: '',
    }
  },
  methods: {
    onConfirm() {
      this.confirm(this.header, this.content)
    },
  },
}
</script>

<style></style>
